import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';

export const XCloseSmallIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1} {...props} viewBox="0 0 12 12" ratio={1}>
            <path d="M11.0557 1.5127L1.50972 11.0586" stroke={props.color? props.color: "currentColor"} strokeWidth="1.49471" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M11.0599 11.0545L1.51392 1.50854" stroke={props.color? props.color: "currentColor"} strokeWidth="1.49471" strokeLinecap="round"
                  strokeLinejoin="round"/>

        </SvgIcon>
    );
}
